<template>
  <v-navigation-drawer
    v-model="navigationDrawerProfile"
    width="320"
  >
    <v-list>
      <v-list-item class="mb-2 px-6">
        <v-list-item-title class="text-h5 font-weight-bold">
          {{ profile.firstName }} {{ profile.lastName }}
        </v-list-item-title>
      </v-list-item>
      <v-divider class="mb-6"></v-divider>
      <v-list-item
        v-for="(section) in profileSections"
        :key="section.id"
        class="px-6 column-gap-2"
        link
        @click="selectProfileSection(section)"
      >
      <template v-slot:prepend>
        <app-material-icon 
          :name="section.icon" 
          :filled="path === `/profile/${section.key}`"
          :class="{'text-primary': path === `/profile/${section.key}`}"
          size="xs"
          type="fa"
          weight="fal"
        />
      </template>
      <v-list-item-title
        class="d-flex column-gap-2 align-center"
        :class="{
          'text-primary': path === `/profile/${section.key}`,
        }"
      >
        {{ $t(section.title) }}
        <template v-if="section.isNew">
          <AppFeatureTag tag="new" />
        </template>
      </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from 'vuex'

import AppFeatureTag from '@/common/AppFeatureTag.vue'
import { GlobalMutationTypes } from '@/store/modules/global/mutation_types'

export default {
  name: 'ProfileNavigationDrawer',
  props: ['profileSections'],
  components: { AppFeatureTag },
  computed: {
    ...mapState('user', ['profile']),
    path () {
      return this.$route.path
    },
    navigationDrawerProfile: {
      get: function () {
        return !this.$vuetify.display.mobile
          ? true
          : this.$store.state.global.navigationDrawerProfile
      },
      set: function (newValue) {
        if (!this.$vuetify.display.mobile) return
        this.$store.commit('global/' + GlobalMutationTypes.SET_NAVIGATION_DRAWER_PROFILE, newValue)
      },
    },
  },
  methods: {
    selectProfileSection (section) {
      this.$router.push(section.key).catch(() => {})
      this.navigationDrawerProfile = false
    },
  },
}
</script>
